"use client";
import React, { useEffect, useState } from "react";
import dynamic from 'next/dynamic';

const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
import styles from "./CareersPage.module.css";
import { motion } from "framer-motion";
import scroll_icon from "@/assets/Icon/Scroll_Icon.png";
import { OnOpenUrl } from "../accordion";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/navigation";
import Image from "next/image"
const data = [
    {
        nameKey: "GameDesign",
    },
    {
        nameKey: "GameDeveloper",
    },
    {
        nameKey: "GameArt",
    },
    {
        nameKey: "Marketing",
    },
    {
        nameKey: "Management",
    },
    {
        nameKey: "QualityAssurance",
    },
    {
        nameKey: "TalentPool",
        url :"careers/tally/3xzRvy"
    }
];
const animationData = [
    ["You", "We"],
    ["the", "you"],
    ["first step", "to the Apex"]
]

const letterAnimation = {

    prev: {
        initial: { y: 0, opacity: 1 },
        animate: { y: "-100%", opacity: 0 }

    },
    current: {
        initial: { y: "0%", opacity: 0 },
        animate: { y: "-100%", opacity: 1 }
    },

    transition: { duration: 0.66, ease: "easeInOut" },
};
// animation variants
const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.1, // 순차적으로 등장
            duration: 0.5,
            ease: "easeOut"
        }
    }),
};
const CarrersPage = () => {
    const [prevIndex, setPrevIndex] = useState(1);
    const [index, setIndex] = useState(0);
    const [hoverIndex, setHoverIndex] = useState(null);
    const router = useRouter();

    useEffect(() => {
        const interval = setInterval(() => {
            setPrevIndex(index);
            setIndex((prev) => (prev + 1) % 2);
        }, 3000); // 3초마다 전환
        return () => clearInterval(interval);
    }, [index]);
    const { t } = useTranslation();
    const [isEmpty, setIsEmpty] = useState(false);
    const handlerClick = (url) => {
        if(!url){
            setIsEmpty(true)
        }
        else{
            OnOpenUrl({content : {url : url}, navigate: router})
        }

        return;
    }
    return (
        <div className={styles.carrers__page}>
            <Header></Header>

            <div className={styles.carrers__container}>

                <div className={styles.header__slogn__container}>

                    <div className={styles.heading_slogn}>
                        <div className={styles.heading__slogn__text__cover}>
                            <motion.span
                                key={`prev_${prevIndex}`}
                                initial={letterAnimation.prev.initial}
                                animate={letterAnimation.prev.animate}
                                transition={letterAnimation.transition}
                                className={styles.heading__slogn__text}>
                                {animationData[0][prevIndex]}
                            </motion.span>

                            <motion.span
                                key={`current_${index}`}
                                initial={letterAnimation.current.initial}
                                animate={letterAnimation.current.animate}
                                transition={letterAnimation.transition}
                                className={styles.heading__slogn__text}>
                                {animationData[0][index]}
                            </motion.span>
                        </div>

                        <div className={styles.heading__slogn__center}>
                            <span className={styles.heading__slogn__text}>
                                take
                            </span>
                            <div className={styles.heading__slogn__text__cover}>

                                <motion.span
                                    key={`prev_${prevIndex}`}
                                    initial={letterAnimation.prev.initial}
                                    animate={letterAnimation.prev.animate}
                                    transition={letterAnimation.transition}
                                    className={styles.heading__slogn__text}>
                                    {animationData[1][prevIndex]}
                                </motion.span>

                                <motion.span
                                    key={`current_${index}`}
                                    initial={letterAnimation.current.initial}
                                    animate={letterAnimation.current.animate}
                                    transition={letterAnimation.transition}
                                    className={styles.heading__slogn__text}>
                                    {animationData[1][index]}
                                </motion.span>
                            </div>
                        </div>
                        <div className={styles.heading__slogn__text__cover}>

                            <motion.span
                                key={`prev_${prevIndex}`}
                                initial={letterAnimation.prev.initial}
                                animate={letterAnimation.prev.animate}
                                transition={letterAnimation.transition}
                                className={styles.gradient__text}>
                                {animationData[2][prevIndex]}
                            </motion.span>

                            <motion.span
                                key={`current_${index}`}
                                initial={letterAnimation.current.initial}
                                animate={letterAnimation.current.animate}
                                transition={letterAnimation.transition}
                                className={styles.gradient__text}>
                                {animationData[2][index]}
                            </motion.span>
                        </div>
                    </div>
                    <div className={styles.scroll__btn}>
                        <Image src={scroll_icon} className={styles.scroll__btn__image} alt="scroll">
                        </Image>
                    </div>
                </div>

                <div className={styles.list}>
                    {data.map((item, index) => (
                        <motion.div
                            key={index}
                            className={styles.scene}
                            onClick={() => handlerClick(item.url)}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.3 }}
                            custom={index}
                            variants={itemVariants}
                        >
                            <span className={`${styles.list__text} ${styles.front}`}>
                                {t(`Careers.${item.nameKey}`)}
                            </span>
                        </motion.div>
                    ))}
                </div>

                {isEmpty &&
                    <div className={styles.dimmed} onClick={() => setIsEmpty(false)}>
                        <div className={styles.popup__content} onClick={(e) => e.stopPropagation()}>
                            <span className={styles.popup__text}>
                                {t("Careers.Fail")}
                            </span>
                            <div className={styles.btn} onClick={() => handlerClick(data[data.length-1].url)}>
                                <span className={styles.btn__text}>
                                {t("Careers.TalentPool")}
                                </span>

                            </div>
                        </div>
                    </div>
                }
            </div>
            <Footer></Footer>
        </div>
    );
}

export default CarrersPage;